enum AdvertisingBannerType {
  STANDARD = 'STANDARD',
  CAROUSEL = 'CAROUSEL'
}

export default AdvertisingBannerType
